function getTimeData(time)
{
    var am_pm=time.substr(time.length-2,time.length);
    var hour=time.substr(0,2);
    var minute=time.substr(3,2);
    if (hour[0]=="0")
    {
        hour=hour[1];
    }
    
    if (am_pm=="PM")
    {
        hour=parseInt(hour)+12;
    }
    
    if (minute[0]=="0")
    {
        minute=minute[1];
    }

    hour=parseInt(hour)+parseInt(minute)/60

    return hour;
}

export function validTime(data,today)
{
    
    var start_hour=getTimeData(data.start_time);
    
    var end_hour=getTimeData(data.end_time);

    var todayhour=getTimeData(today);
    
    
   
    
    if (todayhour>=start_hour && todayhour<=end_hour)
    {
        return true;
    }
    else 
    {
        return false;
    }


    
}